import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./App.css"; // Optional: Import your CSS file for custom styles
import axios from "axios";
import CreatePanModal from "./createPanModel";
import AirlineCredsModal from "./AirlinecredsModel";
import EmailCredsModal from "./EmailcredsModel";

Modal.setAppElement("#root");

const PanModal = ({
  isOpen,
  onRequestClose,
  workspaceId,
  workspaceName,
  existingName,
  existingIsActive,
  existingBoxFolderId,
  onUpdate
}) => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: existingName,
    is_active: existingIsActive,
    box_folder_id:existingBoxFolderId
  });
  const [isCreatePanModalOpen, setIsCreatePanModalOpen] = useState(false);
  const [newPan, setNewPan] = useState("");
  const [newEntityName, setNewEntityName] = useState("");
  const [panCount, setPanCount] = useState(0); // Track PAN count
  const [airlineCredsCounts, setAirlineCredsCounts] = useState({});
  const [selectedPan, setSelectedPan] = useState(null);

  const [emailCredsCounts, setEmailCredsCounts] = useState({});
  const [selectedEmailCreds, setSelectedEmailCreds] = useState([]);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [token, setToken] = useState(null);

  const columnDefs = [
    { headerName: "Pans", field: "pan", width: 300,filter: true, },
    { headerName: "Entity", field: "entity_name", width: 300 },
    {
      headerName: "Airline Creds Count",
      field: "airlinecreds_count",
      width: 200,
      valueGetter: (params) => airlineCredsCounts[params.data.pan] || 0,
      cellClass: "clickable-cell",
    },
    {
      headerName: "Email Creds Count",
      field: "emailcreds_count",
      width: 200,
      valueGetter: (params) => emailCredsCounts[params.data.pan]?.count || 0,
      cellClass: "clickable-cell",
    },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => (
        <button
          style={{
            backgroundColor: "red",
            color: "white",
            height: "40px",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => handleRemoveWorkspace(params.data.pan)}
        >
          Delete
        </button>
      ),
      width: 150,
    },
  ];


  const onCellClicked = (params) => {
    if (params.colDef.field === 'airlinecreds_count' && params.value > 0) {
      setSelectedPan(params.data.pan);
      setIsModalOpen(true);
    }
    if (params.colDef.field === 'emailcreds_count' && params.value > 0) {
      setSelectedPan(params.data.pan);
      setSelectedEmailCreds(emailCredsCounts[params.data.pan]?.emaillogin_ids || []);
      setIsEmailModalOpen(true);
    }
  };

  const fetchAirlineCredsCounts = async () => {
    try {
      const response = await axios.get('https://stage-apiplatform.finkraft.ai/api/meta/airlinecreds/count');
      const counts = response.data.reduce((acc, item) => {
        acc[item.pan] = item.airlinecreds_count;
        return acc;
      }, {});
      setAirlineCredsCounts(counts);
    } catch (error) {
      console.error('Error fetching airline creds counts:', error);
    }
  };


    // Fetch email creds counts
    const fetchEmailCredsCounts = async () => {
      try {
        const response = await axios.get('https://stage-apiplatform.finkraft.ai/api/meta/pan-emailcreds-count');
        const counts = response.data.reduce((acc, item) => {
          acc[item.pan] = {
            count: item.emailcreds_count,
            emaillogin_ids: item.emaillogin_ids,
          };
          return acc;
        }, {});
        setEmailCredsCounts(counts);
      } catch (error) {
        console.error('Error fetching email creds counts:', error);
      }
    };
  
    useEffect(() => {
      const savedToken = sessionStorage.getItem('token');
      if (savedToken) {
        setToken(savedToken);
      }
      if (isOpen) {
        fetchAirlineCredsCounts();
        fetchEmailCredsCounts();
        fetchPans();
        setFormData({ name: existingName, is_active: existingIsActive, box_folder_id: existingBoxFolderId });
      }
    }, [isOpen, workspaceId, existingName, existingIsActive, existingBoxFolderId]);


  // Inside your PanModal component
  const handleRemoveWorkspace = async (panNumber) => {
    // Show confirmation alert
    const userConfirmed = window.confirm(
      `Are you sure you want to delete the PAN ${panNumber}?`
    );
  
    // If the user cancels, do nothing
    if (!userConfirmed) {
      return;
    }
  
    try {
      const response = await fetch(
        `https://stage-apiplatform.finkraft.ai/api/meta/pans/remove-workspace/${panNumber}`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({}), // Replace with actual data if needed
        }
      );
  
      if (response.ok) {
        // Parse the JSON response
        const responseData = await response.json();
  
        // Successfully removed workspace ID
        setRowData((prevRowData) =>
          prevRowData.map((row) =>
            row.pan === panNumber ? { ...row, workspace_id: null } : row
          )
        );
  
        console.log(responseData.message);
        fetchPans();
      } else {
        console.error('Response status not OK:', response.status);
        alert('Failed to remove workspace ID.');
      }
    } catch (error) {
      console.error('Error removing workspace ID:', error);
      alert('Failed to remove workspace ID.');
    }
  };

  
const fetchPans = async () => {
  try {
    const response = await axios.get(
      `https://apiplatform.finkraft.ai/meta/pans/${workspaceId}`
    );
    setRowData(response.data); // Adjust based on the structure of your API response
    setPanCount(response.data.length); // Update the PAN count
    setLoading(false);
  } catch (err) {
    setError("Failed to fetch data.");
    setLoading(false);
  }
};

useEffect(() => {
  if (isOpen) {
    fetchAirlineCredsCounts();
    fetchPans();
    setFormData({ name: existingName, is_active: existingIsActive, box_folder_id: existingBoxFolderId });
  }
}, [isOpen, workspaceId, existingName, existingIsActive, existingBoxFolderId]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = () => {
    setFormData((prev) => ({ ...prev, is_active: !prev.is_active }));
  };

  const handleSubmit = async () => {
    const initialFormData = { name: existingName, is_active: existingIsActive, box_folder_id: existingBoxFolderId };
  
    let workspaceUpdated = false;
  
    if (
      formData.name !== initialFormData.name ||
      formData.is_active !== initialFormData.is_active ||
      formData.box_folder_id !== initialFormData.box_folder_id
    ) {
      workspaceUpdated = true;
  
      try {
        const workspaceResponse = await fetch(
          `https://stage-apiplatform.finkraft.ai/api/meta/workspaces/update/${workspaceId}`, // Send the workspaceId in the URL
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
               "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(formData),
          }
        );
  
        if (workspaceResponse.status === 200) {
          // Update the parent component's row data with the updated form data
          onUpdate({
            workspace_id: workspaceId,
            workspace_name: formData.name,
            is_active: formData.is_active,
            workspace_box_id: formData.box_folder_id,
            pan_count: panCount, // Include the updated PAN count
          });
          console.log("Workspace updated successfully");
          onRequestClose();
        } else {
          console.error("Failed to update workspace")
        }
      } catch (error) {
        console.error(error);
      }
    }
  
    if (workspaceUpdated) {
      // Optionally, you can refresh data or show a success message here
      console.log("Workspace details updated");
    }
  };
  



  const handleClose = async () => {
    // Ensure latest data is fetched before closing
    await fetchPans(); // Refresh the PAN count before closing
    console.log("panCount on close:", panCount); // Debugging log

    onUpdate({
      workspace_id: workspaceId,
      workspace_name: formData.name,
      is_active: formData.is_active,
      workspace_box_id: formData.box_folder_id,
      pan_count: panCount, // Send updated PAN count on close as well
    });

    onRequestClose(); // Close the modal
  };

  return (
    <>
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="PAN Modal"
      className="custom-modal-pan"
      overlayClassName="custom-overlay"
    >
      <h2>PAN Details for Workspace : {workspaceName}</h2>

      {/* Input for Workspace Name */}
      <div>
        <label htmlFor="workspace-name">Workspace Name:</label>
        <input
          type="text"
          id="workspace-name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          placeholder="Enter workspace name"
          className="updateworspace-input"
        />
      </div>
      {/* Input for Box Folder ID */}
      <div className="workspace-div">
        <label>Box Folder ID:</label>
        <input
          type="text"
          name="box_folder_id"
          value={formData.box_folder_id}
          onChange={handleInputChange}
          placeholder="Enter Box Folder ID"
          className="updateworspace-input"
        />
      </div>

      {/* Checkbox for Active Status */}
      <div className="workspace-div">
        <label>
          <input
            type="checkbox"
            checked={formData.is_active}
            onChange={handleCheckboxChange}
          />
          Active
        </label>
      </div>
      <div>
        <button
          onClick={() => setIsCreatePanModalOpen(true)}
          style={{ marginBottom: "10px" }}
        >
          Add Pan
        </button>
        <CreatePanModal
          isOpen={isCreatePanModalOpen}
          onRequestClose={() => setIsCreatePanModalOpen(false)}
          workspaceId={workspaceId}
          workspaceName={existingName} // Auto-filled workspace name
          refreshPanList={fetchPans}
        />
      </div>

      {/* AG Grid for PAN Data */}
      <div className="ag-theme-alpine" style={{height:'300px', width: "100%" }}>
        <AgGridReact
          rowData={rowData}
          onCellClicked={onCellClicked}
          columnDefs={columnDefs}
          defaultColDef={{ flex: 1, minWidth: 100 }} // Ensure columns are responsive
        />
      </div>

      {/* Submit Button */}
      <button onClick={handleSubmit} className="modal-submit-button">
        Submit
      </button>
      <button onClick={handleClose} className="modal-close-button">
        Close
      </button>
      {isModalOpen && (
        <AirlineCredsModal
          pan={selectedPan}
          onClose={() => setIsModalOpen(false)}
          ClassName="airline-creds-overlay"
        />
      )}
       {isEmailModalOpen && (
        <EmailCredsModal
          pan={selectedPan}
          emailCreds={selectedEmailCreds}
          onClose={() => setIsEmailModalOpen(false)}
        />)}
    </Modal>
    </>
    
  );
};

export default PanModal;
